import CustomerModel from "../models/customer";
import { BasicRequest, HTTPMethod } from "../requests";


export class API {
    public static getCustomers(startAt?: number, limit?: number): Promise<Array<CustomerModel>> {
        return new BasicRequest<Array<CustomerModel>>('/api/v1/customers', HTTPMethod.GET, undefined, undefined, startAt, limit).execute()
    }
}